import React from "react";
import { Link } from "react-router-dom";
import { useRole } from "../lib/role.jsx";
import { ShieldAlert, ArrowLeft, Mail } from "lucide-react";

export default function AccessRestricted() {
  const { user, role } = useRole();
  return (
    <div className="min-h-[70vh] flex items-center justify-center px-6 animate-fade-in" data-testid="access-restricted">
      <div className="w-full max-w-lg text-center">
        <div className="w-14 h-14 rounded-sm bg-warning/15 text-warning flex items-center justify-center mx-auto">
          <ShieldAlert size={26} />
        </div>
        <div className="mt-5 text-[10px] uppercase tracking-[0.22em] text-warning font-semibold">Access Restricted</div>
        <h1 className="font-display text-3xl font-semibold tracking-tight mt-2">This module is outside your scope</h1>
        <p className="text-muted text-sm mt-3 leading-relaxed">
          Your role <span className="text-fg font-medium">{role?.name || "Guest"}</span>
          {user?.branchName && <> · scoped to <span className="text-fg font-medium">{user.branchName}</span></>}
          {" "}does not have visibility for this module. If you require access, contact the Executive Data Council.
        </p>

        <div className="mt-7 inline-flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            data-testid="restricted-back-home"
            className="inline-flex items-center gap-2 h-10 px-4 bg-primary text-primary-fg hover:opacity-90 rounded-sm text-sm font-semibold"
          >
            <ArrowLeft size={14} /> Return to Command Center
          </Link>
          <a
            href="mailto:edc@1rotary.ph"
            data-testid="restricted-contact-edc"
            className="inline-flex items-center gap-2 h-10 px-4 border border-border hover:border-primary hover:text-primary rounded-sm text-sm"
          >
            <Mail size={13} /> Contact Data Council
          </a>
        </div>

        {user && (
          <div className="mt-10 text-[10px] uppercase tracking-[0.18em] text-subtle font-mono-tabular">
            Signed in as {user.employeeId} · {user.department}
          </div>
        )}
      </div>
    </div>
  );
}
